import { paletteVar } from "@platform/design-system";

import type { CarrierTier } from "../types";

const TIER_COLORS: Record<CarrierTier, string> = {
  "Tier 1": paletteVar("secondary-main", "#0078a2"),
  // Literal on purpose: design keeps one supporting teal, so the token would
  // draw Tier 2 in Tier 1's colour.
  "Tier 2": "#4fb3cd",
  "Non-Strategic": paletteVar("primary-main", "#832a80"),
  Mixed: "#6b7280",
  Unknown: "#9ca3af",
};

const TIER_ORDER: CarrierTier[] = ["Tier 1", "Tier 2", "Non-Strategic"];

const CARD_SX = {
  bgcolor: paletteVar("background-paper", "#fff"),
  border: `1px solid ${paletteVar("divider", "#e0e0e0")}`,
  borderRadius: 1,
  p: 3,
} as const;

export { TIER_COLORS, TIER_ORDER, CARD_SX };
